interface Stat {
   value: string;
   label: string;
}

export interface StatsSectionProps {
   data: SectionData;
}

export interface SectionData {
   type: 'Stats';
   id: string;
   stats: Stat[];
}

export function StatsSection({ data: { stats } }: StatsSectionProps) {
   return (
      <section className="w-full bg-brand-50 border-1 border-brand-100">
         <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-4 sm:py-7 lg:py-14">
               {stats.map((stat, index) => (
                  <Stats key={index} number={stat.value} helpText={stat.label} />
               ))}
            </div>
         </div>
      </section>
   );
}

interface StatsProps {
   number: string;
   helpText: string;
}

function Stats({ number, helpText }: StatsProps) {
   return (
      <div className="grid justify-center text-center">
         <div className="text-3xl font-semibold text-brand-500">{number}</div>
         <div className="text-base font-medium mx-auto">{helpText}</div>
      </div>
   );
}
